<template>
    <!-- 利益冲突申报 -->
    <div class="interest_container">
        <div class="interest_body" v-if="isShow == 0">
            <div style="text-align:center;"><h4>Integrity Commitment</h4></div>
            <div class="interest_body_content">
                <span>I solemnly make the following commitment:</span>
                <span style="text-indent:2em;display: block;">1. I consciously abide by the laws, regulations and the company's rules and regulations. I am familiar with the "Conflict of Interest Management System" and the "Key Post Overseas Investment Declaration Management Measures" the company has formulated.</span>
                <span style="text-indent:2em;display: block;">2. When there is a conflict of interest between the individual and the profession, I shall report to the company promptly and truthfully and take the initiative to avoid or cooperate with the  company adjustments.</span>
                <span style="text-indent:2em;display: block;">3. I am aware of the conflict of interest and the basic situation of investment, declaration procedures and requirements, penalties and other matters. <span style="color:red;font-weight:bold;">I know that it is dishonest to declare falsely.</span></span>
                <span style="text-indent:2em;display: block;">4. I will earnestly perform my job responsibilities. I will not ask for or accept gifts, securities, valuables, rebates, favors fee, reward for go-between, etc. from the company's business partners, suppliers, and customers for any reason.</span>
                <span style="text-indent:2em;display: block;">5. I strictly abide by professional ethics, and never use power for personal gain. I do not cheat nor do things that damage the interests and image of the company.</span>
                <span style="text-indent:2em;display: block;">6. I am willing to accept the supervision of the company. <span style="color:red;font-weight:bold;">If I violate the promise, I will voluntarily take the responsibility for breaching promise and bear the legal consequences.</span></span>
            </div>

            <div class="interest_bottom_btn" @click="receiptEvent">Accept</div>
        </div>

        <div class="interest_show_content" v-if="isShow == 1">
            <van-swipe style="height: 100%;" :show-indicators="false" :loop="false" @change="swipeChangeEvent" ref="swipe">
                <van-swipe-item v-for="(item, index) in datas" :key="index" style="overflow-y: scroll;">
                    <div class="show_content_box">
                        <div class="content_box_head">
                            <div class="box_head_line"></div>
                            <div class="box_head_title">{{ item.title }}</div>
                            <div class="box_head_num"><span style="font-size:16px; font-weight: 700; color: #333;">{{ index+1 }}</span>/9</div>
                        </div>

                        <div class="content_box_middle">{{ item.quest }}</div>

                        <div class="content_box_select">
                            <div :class="[item.whether == '是' ? 'select_item_block' : 'select_default_block']" @click="selectItemEvent(index,'是')">
                                <div :class="[item.whether == '是' ? 'check_select_block' : 'check_default_block']">
                                    <i class="el-icon-check" v-if="item.whether == '是'" style="color: white;font-size: 14px;"></i>
                                </div>
                                <span class="box_select_text">Yes</span>
                            </div>
                            <div :class="[item.whether == '否' ? 'select_item_block' : 'select_default_block']" style="margin-top: 10px;" @click="selectItemEvent(index,'否')">
                                <div :class="[item.whether == '否' ? 'check_select_block' : 'check_default_block']">
                                    <i class="el-icon-check" v-if="item.whether == '否'" style="color: white;font-size: 14px;"></i>
                                </div>
                                <span class="box_select_text">No</span>
                            </div>
                        </div>

                        <div class="content_box_areatext" v-if="item.whether == '是'">
                            <span class="box_area_title">Declaration description</span>
                            <el-input type="textarea" v-model="item.describe" placeholder="Please Fill Declaration description" :autosize="{minRows:4}" maxlength="500" show-word-limit style="margin-top: 10px; font-size: 14px;"></el-input>
                        </div>
                    </div>
                </van-swipe-item>
            </van-swipe>

            <div class="left_change_btn" v-if="currentPage != 0" @click="pageMuteEvent">
                <i class="el-icon-arrow-left" style="font-size: 30px; color: white;"></i>
            </div>

            <div class="right_change_btn" v-if="currentPage != 8" @click="pageAddEvent">
                <i class="el-icon-arrow-right" style="font-size: 30px; color: white;"></i>
            </div>

            <div class="page_bottom_btn" v-if="currentPage == 8" @click="nextStepEvent">Next</div>
        </div>

        <div class="interest_show_list" v-if="isShow == 2">
            <div class="show_list_block">
                <div class="show_list_item" v-for="(item, index) in datas" :key="index">
                    <div class="list_item_head">
                        <div class="item_head_line"></div>
                        <span class="item_head_title">{{ item.title }}</span>
                    </div>
                    <div class="list_item_quest">{{ item.quest }}</div>
                    <div class="list_item_check">
                        <div class="check_select_block">
                            <i class="el-icon-check" style="color: white;font-size: 14px;"></i>
                        </div>
                        <span class="box_select_text" v-if="item.whether == '是'">Yes</span>
                        <span class="box_select_text" v-if="item.whether == '否'">No</span>
                    </div>
                    <div class="list_item_desc" v-if="item.whether == '是'"><span style="font-weight: 700;">Declaration description：</span>{{ item.describe }}</div>
                </div>

                <FieldUpload :fileIds="fileList" label="Source Annex" @fileChange="fileList=$event"/>

                <div class="show_list_check">
                    <van-checkbox v-model="checked" :disabled="disStatus" shape="square">I promise that I have made the above truthful declaration on the relevant conflict of interest matters and am willing to accept the supervision of the company. If there is any inaccuracy, I am willing to accept the company’s punishment decision.</van-checkbox>
                </div>
            </div>
            <div class="show_list_bottom">
                <div class="list_bottom_btn" v-if="!disStatus" @click="proidStepEvent">Previous</div>
                <!-- <div class="list_limit_btn" v-if="disStatus">Previous</div> -->
                <div class="list_bottom_btn" v-if="checked" @click="onSubmit">Submit</div>
                <div class="list_limit_btn" v-if="!checked">Submit</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data(){
        return{
            isShow:0,
            currentPage:0,
            checked:false,
            disStatus:false,
            no:'1',
            fileList:[],

            datas:[
                {
                    key:'1',
                    title:'Handling Enterprise',
                    quest:'I or in the name of others, alone or in joint venture / joint stock with others, or in the mode of contracting / leasing to run a business.',
                    whether:'',
                    describe:''
                },
                {
                    key:'2',
                    title:'Conflict of Interest between Relatives Handling Enterprises and Companies',
                    quest:'My immediate family members (including my spouse, children, myself and my spouse’s parents) run a business by themselves or in a joint venture/joint stock mode with others, and have business transactions with companies affiliated to Sany Group Co., Ltd., or business operations with Sany competitive relationship. (Except stock trading on the open market, funds, bonds and their derivatives investment, real estate investment).',
                    whether:'',
                    describe:''
                },
                {
                    key:'3',
                    title:'Employment and Part-time Job',
                    quest:'My immediate family members and I work in a supplier, customer, agent, competitor, or part-time job (Includes consulting, consultant or other similar capacity, excluding credentialing forms).',
                    whether:'',
                    describe:''
                },
                {
                    key:'4',
                    title:'Economic Exchanges',
                    quest:'My immediate family and I have borrowing, lending, and business transactions with individuals or units (excluding banking institutions) that do business within my authority.',
                    whether:'',
                    describe:''
                },
                {
                    key:'5',
                    title:'Abuse power for personal gains',
                    quest:'I ustilize company resources to help individuals and their relatives, classmates, friends, etc. to obtain benefits and corresponding opportunities. (For example, the business personnel introduce relatives and friends to work for suppliers under their jurisdiction, and company leaders arrange relatives and friends to work under their own hands, etc.)',
                    whether:'',
                    describe:''
                },
                {
                    key:'6',
                    title:'Kinship',
                    quest:'I have relatives working in the company before and after my employment (including forms of labor dispatch) [Includes: my spouse (and spouse’s parents), parents, children (and their spouse and spouse’s parents), grandparents, grandchildren (and their spouse’s and spouse’s parents), step-parents, step-children (and their spouse’s and spouse’s parents), adoptive parents, adopted children (and their spouses and spouses’ parents), my siblings (and their spouses), uncles, aunts, cousins (and their spouses) nephews (and their spouses)] .',
                    whether:'',
                    describe:''
                },
                {
                    key:'7',
                    title:'Confidentiality and Non-compete Agreement',
                    quest:'The new employee in charge of the technical work has signed a technical “Confidentiality Agreement” with the previous company, and the agreement is within the validity period.',
                    whether:'',
                    describe:''
                },
                {
                    key:'8',
                    title:'Introducing Business',
                    quest:'Directors, personnel of key position personel and core position, or their related persons (including relatives, friends, classmates, and fellow villagers) introduce suppliers to conduct business with Sany (including infrastructure construction, procurement, outsourcing, and parts processing).',
                    whether:'',
                    describe:''
                },
                {
                    key:'9',
                    title:'Other',
                    quest:'Whether I have ever violated the company\'s integrity and honest regulations, and knew or heard that other employees have violated the company\'s integrity and honest regulations.',
                    whether:'',
                    describe:''
                }
            ]
        }
    },

    created(){        
    },
    mounted(){
        document.title='Conflict of interest'
        this.$http.get('/api/ts/v0.1/interest/lastData')
        .then(res=>{
            console.log(res)
            if(res.data){
                // if(res.data.files){
                //     this.fileList = res.data.files.split(',')
                // }else{
                //     this.fileList = []
								// }
								res.data.files = ''
                let datas = JSON.parse(res.data.form)
                this.datas = this.datas.map(item=>{
                    let d = datas.find(itm=>{
                        return itm&&itm.key==item.key
                    })
                    if(d){
                        item.whether = d.whether
                        item.describe = d.describe
                    }
                    return item
                })
            }
        })
    },
    methods:{
        //我接受
        receiptEvent(){
            this.isShow = 1
        },

        //选择答案
        selectItemEvent(index, type){
            this.$set(this.datas[index], 'whether', type)
        },

        //轮播图切换
        swipeChangeEvent(val){
            console.log(val)
            console.log(this.currentPage)
            if(this.currentPage < val){
                if(this.datas[this.currentPage].whether == ''){
                    this.$message.error('Please select whether there is a declared association！')
                    this.$refs.swipe.swipeTo(this.currentPage)
                }else{
                    if(this.datas[this.currentPage].whether == '是'){
                        if(this.datas[this.currentPage].describe == ''){
                            this.$message.error('Please Fill Declaration description！')
                            this.$refs.swipe.swipeTo(this.currentPage)
                        }else{
                            this.currentPage = val
                        }
                    }else{
                        this.currentPage = val
                    }
                    
                }
            }else{
                this.currentPage = val
            }
            
        },

        //页码增加
        pageAddEvent(){
            console.log(this.currentPage)
            if(this.datas[this.currentPage].whether == ''){
                this.$message.error('Please select whether there is a declared association！')
            }else{
                if(this.datas[this.currentPage].whether == '是'){
                    if(this.datas[this.currentPage].describe == ''){
                        this.$message.error('Please Fill Declaration description！')
                    }else{
                        this.$refs.swipe.swipeTo(this.currentPage + 1)
                        this.currentPage += 1
                    }
                }else{
                    this.$refs.swipe.swipeTo(this.currentPage + 1)
                    this.currentPage += 1
                }
                
            }
            
        },

        //页码减少
        pageMuteEvent(){
            console.log(this.currentPage)
            this.$refs.swipe.swipeTo(this.currentPage - 1)
            this.currentPage -= 1
        },

        //下一步
        nextStepEvent(){
            console.log(this.datas)
            if(this.datas[8].whether == ''){
                this.$message.error('Please select whether there is a declared association！')
            }else{
                if(this.datas[8].whether == '是'){
                    if(this.datas[8].describe == ''){
                        this.$message.error('Please Fill Declaration description！')
                    }else{
                        this.isShow = 2
                    }
                }else{
                    this.isShow = 2
                }
                
            }
            
        },

        //上一步
        proidStepEvent(){
            this.isShow = 1
            this.currentPage = 0
        },

        onSubmit(){
            this.Dialog.confirm({
                title:'Warning',
                message:'Please confirm whether to submit the data. The data cannot be modified after submission.'
            }).then(()=>{
                let form = {}
                let list = []
                this.datas.map((item) => {
                    let obj = {
                        describe:item.describe,
                        key:item.key,
                        whether:item.whether
                    }
                    list.push(obj)
                })
                form.form = JSON.stringify(list)
                form.files = this.fileList.join(',')
                this.$http.post('/api/ts/v0.1/interest/save',form)
                .then(res=>{
                    if (res.data == 1) {
                        // this.$message.success('操作成功')
                        this.Dialog.confirm({
                            title:'Remind',
                            message:'Declaration submitted successfully, whether to close the page?'
                        }).then(() => {
                            this.$router.go(-1)
                        }).catch(() => {
                            this.checked = false
                        })
                        // this.form = {}
                    } else if(res.data<0) {
                        // this.$message.error('您提交的数据未变更')
                        this.Dialog.confirm({
                            title:'Remind',
                            message:'Declaration submitted successfully, whether to close the page?'
                        }).then(() => {
                            this.$router.go(-1)
                        }).catch(() => {
                            this.checked = false
                        })
                    }else if(res.data==0){
                        // this.$message.error('操作失败')
                        this.Dialog.alert({
                            title:'Warning',
                            message:'Operation failed！Please contact the Application administrator 田辉阳(tianhy16)'
                        })
                        this.checked = true
                    }else{
                        // this.$message.error('您已经提交过了') 
                        this.Dialog.confirm({
                            title:'Warning',
                            message:'Operation failed！Please contact the Application administrator 田辉阳(tianhy16) err:'+JSON.stringify(res)
                        }).then(() => {
                            this.$router.go(-1)
                        }).catch(() => {
                            this.checked = false
                        })
                    }
                    this.loading = false
                })
                .catch((err)=>{
                    this.loading = false
                    // this.$message.error('操作失败')
                    this.Dialog.alert({
                        title:'Warning',
                        message:'Operation failed！Please contact the Application administrator 田辉阳(tianhy16) err:'+JSON.stringify(err)
                    })
                    this.checked = true
                    this.disStatus = false
                })
            }).catch(()=>{

            })
        },
        validate(){
            let msg;
            this.datas.forEach((item,index)=>{
                if(index!=0&&(!item.whether)){
                    msg = '请您填写第'+(index+2)+'页的数据'
                }else if(item.whether == '是' &&(!item.describe)){
                    msg = '请您填写第'+(index+2)+'页的申报事项描述'
                }
            })
            return msg
        },
        whetherChange(value,index){
            
        }
    }
}
</script>
<style scoped lang="less">
    .interest_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: #f2f2f2;
    }
    .interest_body{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: white;
        overflow-y: scroll;
    }
    .interest_body_content{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
        text-align:justify;
        font-size: 16px;
        line-height: 24px;
    }
    .interest_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 30px;
        margin-bottom: 110px;
    }
    .interest_show_content{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background-image: linear-gradient(180deg,#dee6fc 10%,  #f7f8fd 100%);
    }
    .show_content_box{
        width: 94%;
        height: auto;
        background-color: white;
        border-radius: 4px;
        position: absolute;
        left: 3%;
        top: 60px;
    }
    .content_box_head{
        width: 100%;
        height: auto;
        border-bottom: 1px solid #f5f5f5;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .box_head_line{
        width: 3px;
        height: 14px;
        background-color: rgba(183, 159, 134, 1);
        margin-left: 20px;
    }
    .box_head_title{
        flex: 1;
        height: auto;
        margin-left: 10px;
        font-size: 16px;
        color: #333;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
    }
    .box_head_num{
        width: 40px;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: #666;
        letter-spacing: 3px;
        margin-right: 10px;
    }
    .content_box_middle{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
    }
    .content_box_select{
        width: 100%;
        height: auto;
        padding: 20px;
        box-sizing: border-box;
    }
    .select_item_block{
        width: 100%;
        height: 36px;
        background-color: #e7f8ea;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .select_default_block{
        width: 100%;
        height: 36px;
        border: 1px solid rgba(215, 215, 215, 1);
        border-radius: 4px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .check_select_block{
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #38a65a;
        margin-left: 15px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .check_default_block{
        width: 18px;
        height: 18px;
        border: 1px solid #c5c5c5;
        border-radius: 50%;
        box-sizing: border-box;
        margin-left: 15px;
    }
    .box_select_text{
        display: block;
        font-size: 16px;
        color: #333;
        margin-left: 10px;
    }
    .content_box_areatext{
        width: 100%;
        height: auto;
        padding: 30px 20px;
        box-sizing: border-box;
        margin-bottom: 50px;
    }
    .box_area_title{
        display: block;
        font-size: 16px;
        color: #333;
        text-align: left;
    }
    .left_change_btn{
        width: 54px;
        height: 54px;
        background: radial-gradient(rgb(155, 205, 238, .6) 0,rgb(233, 242, 251, .6) 100%);
        border-radius: 50%;
        position: absolute;
        left: 20px;
        bottom: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .right_change_btn{
        width: 54px;
        height: 54px;
        border-radius: 50%;
        background: radial-gradient(rgb(155, 205, 238, .6) 0,rgb(233, 242, 251, .6) 100%);
        position: absolute;
        right: 20px;
        bottom: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .interest_show_list{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
    }
    .show_list_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 70px;
        background-color: white;
        overflow-y: scroll;
    }
    .show_list_bottom{
        width: 100%;
        height: 70px;
        background-color: white;
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
    }
    .list_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
    .list_limit_btn{
        width: 120px;
        height: 40px;
        background-color: #ccc;
        border-radius: 4px;
        font-size: 16px;
        color: #eee;
        line-height: 40px;
        text-align: center;
    }
    .show_list_item{
        width: 100%;
        height: auto;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }
    .show_list_check{
        width: 100%;
        height: auto;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 16px;
        color: #333;
        text-align: left;
    }
    .list_item_head{
        width: 100%;
        height: auto;
        min-height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .item_head_line{
        width: 3px;
        height: 14px;
        background-color: rgba(183, 159, 134, 1);
    }
    .item_head_title{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
        line-height: 24px;
        text-align: left;
        margin-left: 5px;
    }
    .list_item_quest{
        width: 100%;
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
    }
    .list_item_check{
        width: 100%;
        height: 36px;
        background-color: #e7f8ea;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .list_item_desc{
        width: 100%;
        height: auto;
        background-color: #f2f2f2;
        margin-top: 10px;
        margin-bottom: 10px;
        padding: 10px;
        box-sizing: border-box;
        font-size: 16px;
        color: #333;
        text-align: left;
        line-height: 24px;
    }
    .page_bottom_btn{
        width: 120px;
        height: 40px;
        background-color: #0169ff;
        border-radius: 4px;
        position: absolute;
        left: 50%;
        bottom: 55px;
        margin-left: -60px;
        font-size: 16px;
        color: white;
        line-height: 40px;
        text-align: center;
    }
</style>